import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login.vue')
  },
  {
    path: '/',
    // redirect: "/data-center",
    component: () => import('../layout/Index.vue'),
    children: [
      // 数据中心
      {
        path: '/data-center',
        component: () => import('@/views/data-center/Index.vue'),
        name: 'data-center'
      },
      // 打开外部页面
      {
        path: '/open',
        component: () => import('@/views/open-page/Index.vue'),
        name: 'open'
      },
      // 权限提示
      {
        path: '/limits-of-authority',
        component: () => import('@/views/limits-of-authority/Index.vue'),
        name: 'limits-of-authority'
      },
      // 流量趋势分析
      {
        path: '/model/traffic-trends',
        component: () => import('@/views/analyze-model/traffic-trends/Index.vue'),
        name: 'traffic-trends'
      },
       // 频道流量趋势分析
       {
        path: '/model/traffic-trends/:channel',
        component: () => import('@/views/analyze-model/tranffic-trends-channel/Index.vue'),
        name: 'tranffic-trends-channel'
      },
       // APP运营数据分析
       {
        path: '/model/app-operate-data',
        component: () => import('@/views/analyze-model/app-operate-data/Index.vue'),
        name: 'app-operate-data'
      },
      // 事件分析
      {
        path: '/model/event-study',
        component: () => import('@/views/analyze-model/event-study/Index.vue'),
        name: 'event-study'
      },
      // 频道事件分析
      {
        path: '/model/event-study/:channel',
        component: () => import('@/views/analyze-model/event-study-channel/Index.vue'),
        name: 'event-study'
      },
      // 房源数据分析
      {
        path: '/model/house-data-analyse',
        component: () => import('@/views/analyze-model/house-data-analyse/Index.vue'),
        name: 'house-data-analyse'
      },
      // 客源数据分析
      {
        path: '/model/user-data-analyse',
        component: () => import('@/views/analyze-model/user-data-analyse/Index.vue'),
        name: 'user-data-analyse'
      },
      // 活动私域客流数据统计明细
      {
        path: '/model/agent-passenger-datailed',
        component: () => import('@/views/analyze-model/agent-passenger-datailed/Index.vue'),
        name: 'agent-passenger-datailed'
      },
      // 活动私域客流数据统计
      {
        path: '/model/agent-passenger-query',
        component: () => import('@/views/analyze-model/agent-passenger-query/Index.vue'),
        name: 'agent-passenger-query'
      },
      // 活动公共客流数据统计
      {
        path: '/model/passenger-data-query',
        component: () => import('@/views/analyze-model/passenger-data-query/Index.vue'),
        name: 'passenger-data-query'
      },
      // 活动公共客流数据统计（明细）
      {
        path: '/model/passenger-detailed-query',
        component: () => import('@/views/analyze-model/passenger-detailed-query/Index.vue'),
        name: 'passenger-detailed-query'
      },
      // 活动交易数据统计
      {
        path: '/model/transaction-data-query',
        component: () => import('@/views/analyze-model/transaction-data-query/Index.vue'),
        name: 'transaction-data-query'
      },
      // 核心数据统计
      {
        path:'/model/core-data-statistic',
        component:()=>import('@/views/analyze-model/core-data-statistic/Index.vue'),
        name:'core-data-statistic'
      },
      // 属性配置
      {
        path: '/set/attribute-setting',
        component: () => import('@/views/system-set/attribute-setting/Index.vue'),
        name: 'attribute-setting'
      },
      // 属性配置
      {
        path: '/set/cache-manager',
        component: () => import('@/views/system-set/cache-manager/Index.vue'),
        name: 'cache-manager'
      }
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
